import "./header.css";
import { useEffect, useState } from "react";
import Navbar from "./navbar/Navbar";

const Header = ({ navActive, setNavActive }) => {
  const [headerColor, setHeaderColor] = useState("transparent");

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset === 0) {
        setHeaderColor("transparent");
      } else {
        setHeaderColor("#091214e8");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [headerColor]);

  return (
    <header style={{ backgroundColor: headerColor }}>
        <Navbar navActive={navActive} setNavActive={setNavActive} />
    </header>
  );
};
export default Header;
